function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, "#walk_ico>.cls-1{fill:#1D1899}"));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Calque_2",
  "data-name": "Calque 2"
}, React.createElement("g", {
  id: "walk_ico"
}, React.createElement("path", {
  className: "cls-1",
  d: "M9.87 6.73a3.12 3.12 0 0 0 2.3-1.06 3.27 3.27 0 0 0 .89-2.39A3.36 3.36 0 0 0 12 .93 3 3 0 0 0 9.7 0a3.18 3.18 0 0 0-2.31 1.06 3.45 3.45 0 0 0-.93 2.4 3.12 3.12 0 0 0 1 2.34 3.19 3.19 0 0 0 2.41.93zM21.07 17.93l-4.87-2.65-4-6.38a3.54 3.54 0 0 0-2.81-1.42 3.28 3.28 0 0 0-2.22 1l-6 6.11a1.88 1.88 0 0 0-.35.79L0 22.18v.18a1.46 1.46 0 0 0 .44 1.06 1.44 1.44 0 0 0 1.07.44 1.27 1.27 0 0 0 1-.44 1.87 1.87 0 0 0 .49-1l.62-5.85 2.13-2.12-1.94 16.32-3.46 7.7a3.37 3.37 0 0 0-.17 1 2.25 2.25 0 0 0 .66 1.64 2 2 0 0 0 1.64.57 2.06 2.06 0 0 0 1.95-1.24l3.72-8.34a1.25 1.25 0 0 1 .08-.31c.06-.15.12-.28.18-.4A.79.79 0 0 0 8.5 31l.44-4 3.81 13.11A2.08 2.08 0 0 0 15 41.66a2.13 2.13 0 0 0 1.51-.66 2.2 2.2 0 0 0 .67-1.64.74.74 0 0 0-.05-.22.69.69 0 0 1 0-.22l-5.35-18.15.62-5.94 1.5 2.39a1.71 1.71 0 0 0 .44.45l5.23 2.92a2.8 2.8 0 0 0 .71.18 1.41 1.41 0 0 0 1.06-.49 1.64 1.64 0 0 0 .44-1.11 1.38 1.38 0 0 0-.71-1.24z"
})));

var SvgIcoWalk = function SvgIcoWalk(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 21.78 41.67",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIcoWalk, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ico_walk.a242389c.svg";
export { ForwardRef as ReactComponent };